<app-upsell-card
  htmlTitle="<strong>Important: Replenish</strong> Your Good Bacteria"
  question="We strongly recommend including probiotics in your prescription. Would you like to add it to your treatment plan?"
  [slug]="slug"
>
  <ng-content>
    <p class="mb-4">
      Antibiotics, while effective, can unintentionally disrupt the delicate balance of beneficial bacteria in your gut.
      However, there's a powerful solution: taking extra-strength probiotics.
    </p>
    <p class="mb-4">
      By incorporating these daily for 30 days, both during and after your antibiotic course, you're not just restoring
      but nurturing the essential good bacteria your body craves. This is your key to not only recovering but thriving
      with renewed vitality and well-being.
    </p>
  </ng-content>
</app-upsell-card>
